(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  const initKgHeaderStickyProductMedia = () => {
    const media = document.querySelector('.product-information__media');
    const header = document.querySelector('#header-component[sticky]');
    if (!media || !header) return;

    let announcementInView = false;
    let headerSticky = header.dataset.stickyState === 'active';

    const syncClass = () => {
      media.classList.toggle('kg-header-sticky-product-media', headerSticky && !announcementInView);
    };

    const headerObserver = new MutationObserver(() => {
      headerSticky = header.dataset.stickyState === 'active';
      syncClass();
    });
    headerObserver.observe(header, { attributes: true, attributeFilter: ['data-sticky-state'] });

    const announcement = document.querySelector('#header-group aside.announcement-bar');
    if (announcement) {
      const rect = announcement.getBoundingClientRect();
      announcementInView = rect.bottom > 0 && rect.top < window.innerHeight;

      const announcementObserver = new IntersectionObserver(([entry]) => {
        if (!entry) return;
        announcementInView = entry.isIntersecting;
        syncClass();
      });
      announcementObserver.observe(announcement);
    }

    syncClass();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKgHeaderStickyProductMedia, { once: true });
  } else {
    initKgHeaderStickyProductMedia();
  }

  } catch(e) { console.error(e); }
})();
})();
